import { Box, Typography } from '@material-ui/core';
import StepCheck from 'assets/icons/StepCheck';
import './index.scss'
import { useLocation } from 'react-router-dom';
import { CONTRATO_ETAPAS_PARAMS_URL } from 'models/contratos';

export const ContratoStepItem = ({
  icon,
  isActive,
  isCompleted,
  label,
  isThird,
  isSecond,
  onClick
}) => {
  const location = useLocation();
  const cadastro = location.pathname.includes(CONTRATO_ETAPAS_PARAMS_URL.CADASTRO);
  const edicao = location.pathname.includes(CONTRATO_ETAPAS_PARAMS_URL.EDICAO);

  const labelCompleteClass = isCompleted
    ? 'completedLabel'
    : 'inactive';
  const iconContainerClass = isActive
    ? 'active'
    : labelCompleteClass
  const labelClass = isActive
    ? 'activeLabel'
    : labelCompleteClass;

  const formatLabelSize = (inputLabel) => {
    if (inputLabel.length > 20) {
      const firstPart = inputLabel.slice(0, 20);
      const secondPart = inputLabel.slice(20);
      return (
        <>
          <span>{firstPart}</span>
          <br />
          <span>{secondPart.trim()}</span>
        </>
      );
    }
    return <span>{inputLabel}</span>;
  };

  return (
    <Box
      onClick={onClick}
      className={`contratoItemContainer 
        ${isSecond ? 'secondItem' : ''}
        ${isThird ? 'thirdItem' : ''} 
        ${cadastro ? 'noCursorPointer' : ''}
        ${edicao ? 'cursorPointer' : ''}
      `}
    >
      <Box className={`iconContainer ${iconContainerClass}`}>{icon}</Box>
      <Typography className={`label ${labelClass}`}>
        <span className='iconContainer_label'>
          {isCompleted && (
            <StepCheck color='currentColor' />
          )}
        </span>
        {formatLabelSize(label)}
      </Typography>
    </Box>
  );
};